var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.621 17.213h-3.708l1.679-5.576 5.667 1.159a.624.624 0 10.252-1.222l-7.489-1.545a1.678 1.678 0 00-1.946 1.202l-1.67 5.536A1.734 1.734 0 0012.055 19h4.77l.915 6.255a.878.878 0 001.003.733l.03-.005a.886.886 0 00.733-1.015v-.004l-1.024-7.02a.85.85 0 00-.861-.73zM15.214 6a1.786 1.786 0 11-1.785 1.786A1.786 1.786 0 0115.214 6zm6.826 9.243v-.005a1.249 1.249 0 10-2.497 0v.537a.357.357 0 10.715.003v-.54a.534.534 0 011.069 0l.002.013v10.394a.357.357 0 10.714 0V15.243zm-6.52 4.78h-3.69a2.16 2.16 0 01-2.227-1.527l-1.618-7.11a.5.5 0 00-.974.223l1.618 7.114a3.138 3.138 0 003.202 2.3h3.689a.5.5 0 100-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--priority-seat-seniors-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'PrioritySeatSeniorsCircleIcon';
export default Icon;